import Link from '@pretto/bricks/website/utility/Link'

import styled from 'styled-components'

import { APP_HREF } from '../../config'

export const ERROR_TYPES = [
  'contribution',
  'remaining_life_amount',
  'no_salary',
  'remaining_life_amount_and_indebtedness_rate',
  'indebtedness_rate',
]

export const getErrorByType = type => {
  switch (type) {
    case 'contribution':
      return {
        illustration: 'Coins1',
        message: (
          <p>
            Le montant de votre apport vous permet d’acheter ce bien sans emprunt ! Nous vous invitons à réaliser une{' '}
            <ErrorLink href={APP_HREF}>simulation avancée</ErrorLink> pour avoir des résultats plus précis.
          </p>
        ),
      }

    case 'rla':
      return {
        illustration: 'HidingEyes',
        message: (
          <p>
            Oups ! Il semblerait que votre <strong>reste à vivre</strong> soit insuffisant pour financer votre projet.
            Nous vous invitons à réaliser une <ErrorLink href={APP_HREF}>simulation avancée</ErrorLink> pour avoir des
            résultats plus précis.
          </p>
        ),
      }
    case 'noIncome':
    case 'indebtednessRate_rla':
      return {
        illustration: 'Panic-3',
        message: (
          <p>
            Oups ! Il semblerait que votre <strong>taux d’endettement</strong> dépasse les <strong>35 %</strong>{' '}
            recommandés et que votre <strong>reste à vivre</strong> soit insuffisant. Nous vous invitons à réaliser une{' '}
            <ErrorLink href={APP_HREF}>simulation avancée</ErrorLink> pour avoir des résultats plus précis.
          </p>
        ),
      }

    case 'indebtednessRate':
    default:
      return {
        illustration: 'Girl_Bored',
        message: (
          <p>
            Oups ! Il semblerait que votre <strong>taux d’endettement</strong> dépasse les <strong>35 %</strong>{' '}
            recommandés. Nous vous invitons à réaliser une <ErrorLink href={APP_HREF}>simulation avancée</ErrorLink>{' '}
            pour avoir des résultats plus précis.
          </p>
        ),
      }
  }
}

const ErrorLink = styled(Link)`
  font-weight: bold;
  text-decoration: underline;
`
